const templates = [
  {
    id: "KDNbgwJ6q",
    createdAt: "2026-05-23",
    updatedAt: "2026-05-23",
    label: "Vocabulary",
    data: {
      data: {
        title: "Welcome to the `Markdown`-based Social Media Post Generator  ",
        content:
          "###### Word of the day\n## Elucidation\n---\n###### Definition\n### A clear explanation that makes something easier to understand\n---\n###### Example\n### The teacher’s elucidation helped the students grasp the concept.",
        brand: "lexipop",
        files: [],
      },
      globalProperties: {
        h6: {
          "text-align": "text-left",
          "text-decoration-color": "decoration-transparent",
          "bg-color": "bg-transparent",
          "font-size": "text-lg",
          "border-radius": "rounded-none",
          "border-color": "border-transparent",
          "text-color": "text-gray-300",
          margin: "m-0",
          border: "border-none",
          "text-transform": "normal-case",
          padding: "p-0",
          "font-style": "not-italic",
          "text-decoration": "no-underline",
          "font-weight": "font-bold",
        },
        ol: {
          "text-transform": "normal-case",
          border: "border-none",
          "text-decoration": "no-underline",
          "font-weight": "font-normal",
          "list-style-position": "outside",
          padding: "p-0",
          "font-style": "not-italic",
          "text-color": "text-inherit",
          "border-color": "border-transparent",
          margin: "m-0",
          "border-radius": "rounded-none",
          "text-align": "text-left",
          "text-decoration-color": "decoration-transparent",
          "bg-color": "bg-transparent",
        },
        brand: {
          "text-align": "text-left",
          "text-decoration-color": "decoration-transparent",
          "bg-color": "bg-transparent",
          "font-size": "text-sm",
          "border-radius": "rounded-none",
          "text-color": "text-white",
          "border-color": "border-transparent",
          margin: "m-0",
          "text-transform": "normal-case",
          border: "border-none",
          "text-decoration": "no-underline",
          "font-weight": "font-normal",
          padding: "p-0",
          "font-style": "not-italic",
        },
        ul: {
          "text-transform": "normal-case",
          border: "border-none",
          "text-decoration": "no-underline",
          "font-weight": "font-normal",
          padding: "p-0",
          "list-style-position": "outside",
          "font-style": "not-italic",
          "text-color": "text-inherit",
          "border-color": "border-transparent",
          margin: "m-0",
          "border-radius": "rounded-none",
          "text-align": "text-left",
          "text-decoration-color": "decoration-transparent",
          "bg-color": "bg-transparent",
        },
        files: {
          width: "w-4/5",
          overflow: "overflow-hidden",
          border: "border-none",
          "border-radius": "rounded-xl",
        },
        h3: {
          "text-color": "text-inherit",
          "border-color": "border-transparent",
          margin: "m-0",
          "text-transform": "normal-case",
          border: "border-none",
          "font-weight": "font-bold",
          "text-decoration": "no-underline",
          "font-style": "not-italic",
          padding: "p-0",
          "bg-color": "bg-transparent",
          "text-decoration-color": "decoration-transparent",
          "text-align": "text-left",
          "font-size": "text-3xl",
          "border-radius": "rounded-none",
        },
        pagination: {
          "text-transform": "normal-case",
          border: "border-none",
          "font-weight": "font-normal",
          "text-decoration": "no-underline",
          undefined: "decoration-4",
          padding: "p-0",
          "font-style": "not-italic",
          position: "absolute",
          "text-color": "text-inherit",
          "border-color": "border-transparent",
          margin: "m-0",
          bottom: "bottom-4",
          "border-radius": "rounded-none",
          "text-align": "text-left",
          "text-decoration-color": "decoration-transparent",
          right: "right-12",
          "bg-color": "bg-transparent",
          "font-size": "font-sm",
        },
        code: {
          "border-radius": "rounded",
          "text-align": "text-left",
          "text-decoration-color": "decoration-transparent",
          "bg-color": "bg-gray-800",
          "text-decoration": "no-underline",
          "font-weight": "font-bold",
          padding: "p-1",
          "font-style": "not-italic",
          "text-transform": "normal-case",
          border: "border-none",
          margin: "m-0",
          "text-color": "text-gray-500",
          "border-color": "border-transparent",
        },
        h4: {
          "border-color": "border-transparent",
          "text-color": "text-inherit",
          margin: "m-0",
          border: "border-none",
          "text-transform": "normal-case",
          padding: "p-0",
          "font-style": "not-italic",
          "font-weight": "font-bold",
          "text-decoration": "no-underline",
          "text-align": "text-left",
          "bg-color": "bg-transparent",
          "text-decoration-color": "decoration-transparent",
          "font-size": "text-2xl",
          "border-radius": "rounded-none",
        },
        "raw-root-editor": {
          "font-size": "text-md",
          "text-align": "text-left",
          "bg-color": "bg-gray-900",
          "font-family": "font-source-sans-pro",
          "flex-direction": "flex-col",
          gap: "gap-6",
          "align-items": "items-center",
          overflow: "overflow-hidden",
          select: "select-none",
          "justify-content": "justify-center",
          position: "relative",
          "text-color": "text-white",
          display: "flex",
          "font-weight": "font-normal",
        },
        h1: {
          "font-weight": "font-bold",
          "text-decoration": "no-underline",
          padding: "p-0",
          "font-style": "not-italic",
          "text-transform": "normal-case",
          border: "border-none",
          margin: "m-0",
          "text-color": "text-inherit",
          "border-color": "border-transparent",
          "border-radius": "rounded-none",
          "font-size": "text-5xl",
          "text-align": "text-left",
          "text-decoration-color": "decoration-transparent",
          "bg-color": "bg-transparent",
        },
        h5: {
          "text-transform": "normal-case",
          border: "border-none",
          "font-weight": "font-bold",
          "text-decoration": "no-underline",
          "font-style": "not-italic",
          padding: "p-0",
          "text-color": "text-inherit",
          "border-color": "border-transparent",
          margin: "m-0",
          "border-radius": "rounded-none",
          "text-decoration-color": "decoration-transparent",
          "bg-color": "bg-transparent",
          "text-align": "text-left",
          "font-size": "text-xl",
        },
        title: {
          margin: "m-0",
          "border-color": "border-transparent",
          "text-color": "text-inherit",
          "font-style": "not-italic",
          padding: "p-0",
          "text-decoration": "no-underline",
          "font-weight": "font-bold",
          border: "border-none",
          width: "w-4/5",
          "text-transform": "normal-case",
          "font-size": "text-4xl",
          "bg-color": "bg-transparent",
          "text-decoration-color": "decoration-transparent",
          "text-align": "text-center",
          "border-radius": "rounded-none",
        },
        blockquote: {
          "text-color": "text-inherit",
          "border-color": "border-transparent",
          margin: "m-0",
          "text-transform": "normal-case",
          border: "border-none",
          "font-weight": "font-normal",
          "text-decoration": "no-underline",
          "font-style": "not-italic",
          padding: "p-0",
          "bg-color": "bg-transparent",
          "text-decoration-color": "decoration-transparent",
          "text-align": "text-left",
          "border-radius": "rounded-none",
        },
        strong: {
          "border-radius": "rounded-none",
          "text-align": "text-left",
          "bg-color": "bg-transparent",
          "text-decoration-color": "decoration-transparent",
          "text-transform": "normal-case",
          border: "border-none",
          "font-weight": "font-bold",
          "text-decoration": "no-underline",
          padding: "p-0",
          "font-style": "not-italic",
          "text-color": "text-gray-500",
          "border-color": "border-transparent",
          margin: "m-0",
        },
        content: {
          "flex-direction": "flex-col",
          gap: "gap-4",
          margin: "m-0",
          "align-items": "flex-start",
          "justify-content": "justify-center",
          "text-color": "text-inherit",
          "border-color": "border-transparent",
          display: "flex",
          "font-weight": "font-normal",
          "text-decoration": "no-underline",
          padding: "p-0",
          "font-style": "not-italic",
          "text-transform": "normal-case",
          width: "w-1/2",
          border: "border-none",
          "font-size": "text-2xl",
          "text-align": "text-left",
          "text-decoration-color": "decoration-transparent",
          "bg-color": "bg-transparent",
          "border-radius": "rounded-none",
        },
        a: {
          "bg-color": "bg-transparent",
          "text-decoration-color": "decoration-red-500",
          "text-align": "text-left",
          "border-radius": "rounded-none",
          margin: "m-0",
          "text-color": "text-inherit",
          "border-color": "border-transparent",
          undefined: "decoration-4",
          "text-decoration": "underline",
          "font-weight": "font-normal",
          "font-style": "not-italic",
          padding: "p-0",
          "text-transform": "normal-case",
          border: "border-none",
        },
        hr: {
          "border-radius": "rounded-md",
          border: "border",
          width: "w-2/3",
          "border-color": "border-gray-700",
          undefined: "my-1",
          "border-style": "border-solid",
          padding: "p-0",
        },
        table: {
          "border-radius": "rounded-none",
          "bg-color": "bg-transparent",
          "text-decoration-color": "decoration-transparent",
          "text-align": "text-left",
          border: "border-none",
          "text-transform": "normal-case",
          "font-style": "not-italic",
          padding: "p-0",
          "font-weight": "font-normal",
          "text-decoration": "no-underline",
          "border-color": "border-transparent",
          "text-color": "text-inherit",
          margin: "m-0",
        },
        h2: {
          "text-color": "text-gray-200",
          "border-color": "border-transparent",
          margin: "m-0",
          "text-transform": "normal-case",
          border: "border-none",
          "text-decoration": "no-underline",
          "font-weight": "font-bold",
          padding: "p-0",
          "font-style": "not-italic",
          "text-align": "text-left",
          "text-decoration-color": "decoration-transparent",
          "bg-color": "bg-transparent",
          "font-size": "text-7xl",
          "border-radius": "rounded-none",
        },
      },
      localProperties: {},
      propertyType: "global",
      pages: [
        {
          label: "Instagram Post (1080x1350)",
          platform: "instagram",
          containerWidth: 1080,
          containerHeight: 1350,
          className: "h-[1350px] w-[1080px]",
          layout: [
            {
              key: "title",
            },
            {
              key: "content",
            },
            {
              type: "media",
              key: "files",
            },
            {
              key: "brand",
            },
          ],
        },
      ],
      activePlatform: "instagram",
      postVariant: "multipage",
      zoomLevel: 0.6,
      view: "col",
      layoutConfig: {
        files: {
          key: "files",
          activeVariant: null,
          type: "file",
          order: 3,
          variants: [],
          visible: true,
        },
        brand: {
          activeVariant: null,
          key: "brand",
          rows: 1,
          type: "input",
          visible: true,
          variants: [],
          order: 0,
        },
        title: {
          key: "title",
          activeVariant: null,
          rows: 6,
          type: "textarea",
          visible: false,
          order: 1,
          variants: [],
        },
        content: {
          type: "textarea",
          order: 2,
          variants: [],
          visible: true,
          activeVariant: null,
          key: "content",
          rows: 20,
        },
      },
      apiConfig: {
        responseObj: "data",
        cursor: "",
        queryString: "",
        cursorMapping: "",
        contentMapping: "content",
        endpoint: "",
        titleMapping: "title",
      },
    },
  },
].map((template) => ({
  ...template,
  id: `global:${template.id}`,
}));

export default templates;
